import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";

@Injectable({
  providedIn: 'root'
})
export class ApplicationconfigurationService {

      constructor(private httpClient: HttpClient,private route:Router){}
      baseproperties: Baseproperties = new Baseproperties(); 
      private baseURL = this.baseproperties.gatewayBaseURL+'/common'; 

      getgrid(): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/orgconfiguration/getgrid`);
      }
      exceldownload(){    
         return this.httpClient.get(`${this.baseURL}/orgconfiguration/exceldownload`,{ responseType: 'blob' }); 
      }
      getConfigurationbyid(id): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/orgconfiguration/getgrid`);
      }
      getproductforlist(): Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/orgconfiguration/productdata`);
      }
      getconfigdetailsbyId(id):Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/orgconfiguration/getconfiguration/${id}`);

      }
      addappconfigdata(payload):Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/orgconfiguration/addconfiguration/`,payload);

      }

      modifyappconfigdatasuperadmin(payload):Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/orgconfiguration/modifyconfigurationsuperadmin/`,payload);

      }
      modifyappconfigdataadmin(payload):Observable<any>{
        return this.httpClient.post<Observable<any>>(`${this.baseURL}/orgconfiguration/modifyconfigurationadmin/`,payload);

      }



}
